import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';

 export default function each(obj, iterator, context = null) {
  if (isObject(obj) && !isArray(obj)) {
    for (var key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      if (iterator.call(context, obj[key], key, obj) === false) break;
    }
  } else if (isNumber(obj.length)) {
    for (var i = 0; i < obj.length; i++) {
      if (iterator.call(context, obj[i], i, obj) === false) break;
    }
  }
}



// WEBPACK FOOTER //
// ../x/packages/util/src/each.js